import { connect } from 'react-redux';
import Inputs from './Inputs';


const mapStateToProps = state => ({
    projectState: state.projectaddress.projectState,
    resiToggle: state.tax.resiToggle,
    taxEntity: state.tax.taxEntity,
    cashprice: state.solar.cashprice,
});

const combinedActions = {
};

export default connect(mapStateToProps, combinedActions)(Inputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/index.js